import { render, staticRenderFns } from "./FoldNav.vue?vue&type=template&id=422be874&scoped=true&"
import script from "./FoldNav.vue?vue&type=script&lang=js&"
export * from "./FoldNav.vue?vue&type=script&lang=js&"
import style0 from "./FoldNav.vue?vue&type=style&index=0&id=422be874&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422be874",
  null
  
)

export default component.exports